import { DataTable } from "simple-datatables";

export function initDemoTable() {
    const dataTable = new DataTable("#demoTable");

    let tableData = {
        headings: ["Heading 1", "Heading 2", "Heading 3", "Heading 4"],
        data: [
            ["Cell 1", "Cell 2", "Cell 3", "Cell 4"],
            ["Cell 5", "Cell 6", "Cell 7", "Cell 8"],
            ["Cell 9", "Cell 10", "Cell 11", "Cell 12"],
            ["Cell 1", "Cell 2", "Cell 3", "Cell 4"],
            ["Cell 5", "Cell 6", "Cell 7", "Cell 8"],
            ["Cell 9", "Cell 10", "Cell 11", "Cell 12"],
            ["Cell 1", "Cell 2", "Cell 3", "Cell 4"],
            ["Cell 5", "Cell 6", "Cell 7", "Cell 8"],
            ["Cell 9", "Cell 10", "Cell 11", "Cell 12"],
            ["Cell 1", "Cell 2", "Cell 3", "Cell 4"],
            ["Cell 5", "Cell 6", "Cell 7", "Cell 8"],
            ["Cell 9", "Cell 10", "Cell 11", "Cell 12"],
        ],
    };

    dataTable.insert(tableData);
}
